import {
  Box,
  Paper,
  Stack,
  TableContainer,
  useMediaQuery,
} from "@mui/material";
import { operationsDashboardStyles } from "../../OperationsDashboard/styles";
import theme from "../../../utils/theme";
import FilterIcon from "../../../assets/img/sliders-horizontal.svg";
import { DEFAULT_INFO_NOTE } from "../Constants/constants";
import { revenueAndBilledHoursStyles } from "../Styles/styles";
import { hierarchyTableStyles } from "../Styles/hierarchyTableStyles";
import type { RevenueAndBilledHoursContentProps } from "../Types/types";
import { HierarchyTable } from "./HierarchyTable/HierarchyTable";
import { HierarchyTableInfoSection } from "./HierarchyTable/HierarchyTableInfoSection";

export const Content = ({
  hasActiveFilters = false,
  onFilterClick,
  costType = "actual",
  onCostTypeChange,
  isBlendedRevenue = false,
  dateStart,
  dateEnd,
  data,
  total,
  onExpandNode,
  loadingIds,
}: RevenueAndBilledHoursContentProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const renderMobileFilter = () => {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={operationsDashboardStyles.filterIconContainer}
          onClick={onFilterClick}
        >
          <img
            style={operationsDashboardStyles.filterIcon}
            src={FilterIcon}
            alt="filter icon"
          />
          {hasActiveFilters && (
            <Box sx={operationsDashboardStyles.filterIconBadge} />
          )}
        </Box>
      </Stack>
    );
  };

  const renderTableContainer = () => {
    return (
      <Stack spacing={0} sx={hierarchyTableStyles.tableContainerStack}>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={revenueAndBilledHoursStyles.tableContainer}
        >
          <HierarchyTable
            data={data}
            total={total}
            dateStart={dateStart}
            dateEnd={dateEnd}
            onExpandNode={onExpandNode}
            loadingIds={loadingIds}
          />
        </TableContainer>
        <HierarchyTableInfoSection note={DEFAULT_INFO_NOTE} />
      </Stack>
    );
  };

  return (
    <Stack spacing={0} sx={revenueAndBilledHoursStyles.contentStack}>
      {isMobile && renderMobileFilter()}
      {renderTableContainer()}
    </Stack>
  );
};
